import { render, staticRenderFns } from "./SafetyConfirmRegisterInput.vue?vue&type=template&id=949773d0&lang=pug"
import script from "./SafetyConfirmRegisterInput.vue?vue&type=script&lang=ts"
export * from "./SafetyConfirmRegisterInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports